import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrandLogoMobile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 65,
	height: 29,
	viewBox: "0 0 65 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	role: "img",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M48.5843 0.000488281H16.2881C16.2806 8.91841 23.504 16.14 32.4226 16.1478C41.3408 16.1553 48.5768 8.91841 48.5843 0.000488281Z",
			fill: "#C0543A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0635 0H0V28.0177H14.0635V0Z",
			fill: "#C0543A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.8604 0H50.7969V28.0236H64.8604V0Z",
			fill: "#C0543A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.5087 28.0218C41.509 27.9903 41.5112 27.9628 41.5112 27.9309C41.5155 22.9125 37.4504 18.8408 32.4317 18.8364C27.413 18.8321 23.341 22.8969 23.3369 27.9153C23.3369 27.9496 23.3391 27.9875 23.3394 28.0215L41.5087 28.0218Z",
			fill: "#C0543A"
		})
	]
});
export default SvgBrandLogoMobile;
